// @ts-nocheck

import "./index.less";
function customGetSearchQuillText(quill) {
  console.log('customGetSearchQuillText');
  return quill.getContents().filter(function (op) {
    return typeof op.insert === 'string' || op.insert;
  }).map(function (op) {
    if (op.insert.image || op.insert.fileBlot || op.insert.mention || op.insert.piLink) {
      return 'i';
    }
    return op.insert;
  }).join('');
}
function getIndicesOf(_searchStr, _str, caseSensitive = false) {
  let str = _str;
  let searchStr = _searchStr;
  let searchStrLen = searchStr.length;
  if (searchStrLen === 0) {
    return [];
  }
  let startIndex = 0,
    index,
    indices = [];
  if (!caseSensitive) {
    str = str.toLowerCase();
    searchStr = searchStr.toLowerCase();
  }
  while ((index = str.indexOf(searchStr, startIndex)) > -1) {
    indices.push(index);
    startIndex = index + searchStrLen;
  }
  return indices;
}
export default class HighlightKeyWords {
  quill;
  searchTimer = 0;
  keyWords = [];
  moduleContainer;
  constructor(quill) {
    this.quill = quill;
    this.moduleContainer = this.quill.addContainer('ql-highlight-keywords-module-container');
    // 内容变化时，判断图片加载情况，更新高亮
    this.quill.on('editor-change', (e, delta) => {
      if (e === 'text-change') {
        const imgs = delta.filter(x => x && x.insert && x.insert.image);
        if (imgs.length) {
          imgs.forEach(x => {
            const img = new Image();
            img.src = x.insert.image;
            if (img.complete) {
              this.run(this.keyWords);
            }
            img.onload = () => {
              this.run(this.keyWords);
            };
          });
        }
      }
    });
  }
  run(words) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.highlightSearchKeywords(words);
    }, 200);
  }
  highlightSearchKeywords(words) {
    this.keyWords = words;
    this.moduleContainer.innerHTML = '';
    if (!this.keyWords.length) return null;
    const text = customGetSearchQuillText(this.quill);
    const matches = [];
    this.keyWords.forEach(word => {
      const wordMatchs = getIndicesOf(word, text);
      if (wordMatchs.length) {
        wordMatchs.forEach(x => {
          matches.push({
            index: x,
            length: word.length,
            keyword: word,
            bounds: this.quill.getBounds(x, word.length)
          });
        });
      }
    });
    let minIndex = null;
    if (matches.length) {
      matches.forEach(x => {
        minIndex = minIndex === null ? x.index : Math.min(minIndex, x.index);
        this.moduleContainer.appendChild(this.createHighlightElement(x.bounds));
      });
    }
    return minIndex;
  }
  createHighlightElement(bounds) {
    const el = document.createElement('span');
    el.style.position = 'absolute';
    el.style.left = `${bounds.left}px`;
    el.style.top = `${bounds.top}px`;
    el.style.width = `${bounds.width}px`;
    el.style.height = `${bounds.height}px`;
    el.style.backgroundColor = '#96FFD7';
    return el;
  }
}